import { isLoggedIn } from '@/auth'

// initial state
const state = {
  authenticated: isLoggedIn(),
  profileCompleted: false
}

// getters
const getters = {}

// actions
const actions = {
  logIn: ({ commit }) => commit('setAuthenticated', true),
  logOut: ({ commit }) => {
    commit('setAuthenticated', false)
    commit('setProfileCompleted', false)
  }
}

// mutations
const mutations = {
  setAuthenticated(state, authenticated) {
    state.authenticated = authenticated
  },
  setProfileCompleted(state, profileCompleted) {
    state.profileCompleted = profileCompleted
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
